import { autocompleteDropdown } from "./autocomplete_dropdown/autocompleteDropdown.directive";
import { $dropdownObject } from "./dropdownObject.factory";

export const DROPDOWNS_MODULE = angular.module('dropdowns', []);

DROPDOWNS_MODULE.factory('$dropdownObject', $dropdownObject);
DROPDOWNS_MODULE.directive('autocompleteDropdown', autocompleteDropdown);
